import { Component, Input } from '@angular/core';
import { LLTTFInvitations, LLTTFInvitationsDefaultValue } from '../llttf-invitations';
import { LlttfInvitationService } from 'src/app/services/llttf-invitation.service';
import { Router } from '@angular/router';
import { ToastService } from 'src/app/services/toast-service.service';
import { OrganizationService } from 'src/app/services/organization.service';
import { ApplicationProgramsService } from 'src/app/services/application-programs.service';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'app-llttf-invitation-form',
    templateUrl: './llttf-invitation-form.component.html',
    styleUrls: ['./llttf-invitation-form.component.scss'],
    standalone: false
})
export class LlttfInvitationFormComponent {
  @Input() llttfinvitation:LLTTFInvitations=LLTTFInvitationsDefaultValue()
  @Input() isSubmitted:boolean=false;

  programs:any[]=[]
  facilitator:any[]=[]
  filteredFacilitator:any[]=[]
  organizations:any[]=[]
  orgdisabled:boolean=false;
  facilitatordisabled:boolean=false;
  constructor(
    private llttfinvitationservice:LlttfInvitationService,
    private router:Router,
    private toastservice:ToastService,
    private orgservice:OrganizationService,
    private programservice:ApplicationProgramsService,
    private userservice:UserService
  ) { }
  ngOnInit(): void {

    this.orgservice.getOrganizationForUser().subscribe({
      next:(response)=>{
        this.organizations=response
        },
    })

    this.programservice.getLLTTFPrograms().subscribe({
      next:(response)=>{
        this.programs = response
      }
    })

    this.userservice.getLLTTFFacilitatorUsers().subscribe({
      next:(response)=>{
        this.facilitator = this.filteredFacilitator =response
        this.llttfinvitationservice.getPrefilledDataForFacilitator().subscribe({
          next:(response)=>{
            this.llttfinvitation.organizationId = response.organizationId
            this.llttfinvitation.facilitatorId = response.facilitatorId
            this.llttfinvitation.isLoggedInUserFacilitator = response.isLoggedInUserFacilitator
          }
        })
      }
    })
  }

  chkLinkExpiryDate():boolean
  {
    if(this.llttfinvitation.linkExpiryDate != null &&  new Date(this.llttfinvitation.linkExpiryDate) > new Date() && 
    new Date(this.llttfinvitation.linkExpiryDate)> new Date(this.llttfinvitation.programStartDate!))
    {
      return true;
    }
    else
    {
      return false;
    }
  }

  bindFacilitator()
  {
    const selectedOrgId = (this.llttfinvitation.organizationId || '').toString().toLowerCase();
    if (!selectedOrgId) {
      this.filteredFacilitator = this.facilitator;
      return;
    }

    this.filteredFacilitator = this.facilitator.filter(f =>
      (f.orgId || '').toString().toLowerCase() === selectedOrgId
    );

    // Clear facilitator if it no longer belongs to the selected organization
    const stillValid = this.filteredFacilitator.some(
      f => f.userDbId === this.llttfinvitation.facilitatorId
    );
    if (!stillValid) {
      this.llttfinvitation.facilitatorId = 0;
    }
  }

  validateReqFileds():boolean
  {
    let flag=true;
    if(this.llttfinvitation.cohortName == null||this.llttfinvitation.cohortName=='')
    {
      flag=false;
    }
    if(this.llttfinvitation.programId==0||this.llttfinvitation.programId==null)
    {
      flag=false;
    }
    if(!this.llttfinvitation.organizationId)
    {
      flag=false;
    }
    if(this.llttfinvitation.facilitatorId==0||this.llttfinvitation.facilitatorId==null)
    {
      flag=false;
    }
    if(this.llttfinvitation.languageId==0||this.llttfinvitation.languageId==null)
    {
      flag=false;
    }
    if(this.llttfinvitation.noOfParticipants==0||this.llttfinvitation.noOfParticipants==null)
    {
      flag=false;
    }
    if(this.llttfinvitation.programStartDate == null)
    {
      flag=false;
    }
    if(!this.chkLinkExpiryDate())
    {
      flag=false;
    }
    return flag
  }

  radiochange()
  {
    
  }
}
